import type DMApplicationConfigResponse from '#src/types/DMApplicationConfigResponse'
import axiosInstance from './axiosInstance'

const getAppConfigData = (configUrl: string) =>
  axiosInstance.get<DMApplicationConfigResponse>(configUrl)

export { getAppConfigData }
